import * as React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"
import { FieldItems, Input } from "@tenforce/toolbox-field-react"

import { Symbols } from "@tenforce/toolbox-fontmap"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    filter: string
    hasMore: boolean
    isLoading: boolean
    loadMoreLabel: string
    noResults: string
    title: string
    loadMore: () => void
    updateFilter: (newFilter: string) => void
    isInverted: boolean
    placeholder: string
}

export default class ContentWidgetBase extends React.Component<Props> {
    static defaultProps: Partial<Props> = {
        isInverted: false,
    }

    render(): JSX.Element {
        const {
            filter,
            hasMore,
            isLoading,
            loadMoreLabel,
            noResults,
            title,
            loadMore,
            updateFilter,
            children,
            isInverted,
            placeholder,
        } = this.props

        return (
            <div
                className="tw-mb-4 tw-mx-2 theme-bubble bg-cloud tw-px-2 tw-pb-2 tw-items-start has-hidden-actions"
                data-ft-content-widget
            >
                <header className="step-header">
                    <h3 className="tw-my-2">{title}</h3>
                    <FieldItems
                        extraClasses={`tw-flex-1 ${
                            !filter && "is-hidden-action"
                        }`}
                        isInverted={isInverted}
                    >
                        <Input
                            type="search"
                            placeholder={placeholder}
                            value={filter}
                            onChangedValue={updateFilter}
                            data-ft-content-filter
                        />
                    </FieldItems>
                </header>

                <div
                    className={`tw-p-2 tw-pt-0 ${isLoading && "is-loading"}`}
                    data-ft-content-list-container
                >
                    {noResults && (
                        <div className="tw-my-2 tw-mx-6 text-dimmed">
                            {noResults}
                        </div>
                    )}

                    {children}

                    {!isLoading && hasMore && (
                        <div className="tw-mr-4">
                            <Action
                                onClick={loadMore}
                                extraClasses="theme-thumb tw-w-full"
                                data-ft-load-more
                            >
                                <h3 className="text-action tw-mr-2">
                                    {Symbols.ExpandDoubleArrowDown}
                                </h3>
                                <div>
                                    <div className="p text-action">
                                        {loadMoreLabel}
                                    </div>
                                </div>
                            </Action>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
